import { MatDialog, MatSnackBar } from '@angular/material';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '../../../../../node_modules/@angular/router';
import { DataService } from 'src/app/services/data.service';
import { AddTrainingLevelComponent } from './add-training-level/add-training-level.component';
import { List } from 'src/app/stores/administrator/list.store';
import { AuthService } from 'src/app/auth/auth.service';
import { AuthStore } from 'src/app/stores/auth/auth.store';

@Component({
  selector: 'app-training-level',
  templateUrl: './training-level.component.html',
  styleUrls: ['./training-level.component.scss']
})
export class TrainingLevelComponent implements OnInit {
  PROGRAMS = [];
  SELECTED_PROGRAM: any = null;
  PROCESS: boolean = false;

  constructor(
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    public store: List,
    public ds: DataService,
       public auth: AuthStore,
  ) { }

  async ngOnInit() {
    this.PROCESS = true;
    this.PROGRAMS = await this.store.fetchList(this.ds.adprogramCollectRef())
    this.route.params.subscribe(async params => {
      const { id } = params;
      this.SELECTED_PROGRAM = await this.store.fetchDoc(this.ds.adprogramCollectRef().doc(id));
      this.store.fetchData(this.ds.trainingProgramRef(ref => ref.orderBy('order')))
      this.PROCESS = false;
    })
  }

  create() {
    let dialogRef = this.dialog.open(AddTrainingLevelComponent, {
      data: this.SELECTED_PROGRAM,
      panelClass: 'register-test-overlay-panel',
      width: '35vw',
      height: '100vh',
      disableClose: true,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => { });
  }
}